import React from 'react';
import { Box, Text, ToastAction, ToastType } from '@bechtel/gds';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';

const ToastMessage = ({ msg }) => {
  const { i18n } = useLingui();
  return (
    <Box p={{ sm: '500' }} flexDirection={{ sm: 'column' }}>
      <Text family="graphik" weight="600" size="500">
        {i18n._(msg)}
      </Text>
    </Box>
  );
};

const UpdatePermissionsToast = () => {
  return <ToastMessage msg={t`Permissions successfully saved.`} />;
};

const RestorePermissionsToast = () => {
  return <ToastMessage msg={t`Permissions successfully restored.`} />;
};

export function createSuccessToast(isRestorePermissionsToast: boolean = false): ToastAction {
  const toastAction: ToastAction = {
    type: 'ADD_TOAST',
    payload: {
      toastType: ToastType.INFO,
      content: isRestorePermissionsToast ? RestorePermissionsToast : UpdatePermissionsToast,
      autoDismissTimeout: 5000,
    },
  };
  return toastAction;
}
